export default __webpack_public_path__ + "static/media/index2.f3d02d40.jpeg";